export type TypesMapKeys = 'product' | 'pack';

export const typesMap = {
  product: 'P',
  pack: 'G',
};
